var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoRecordRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 145,
    viewBox: "0 0 196 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M6.89011 44.5994C16.9902 -4.49023 109.488 -11.4355 147.951 16.8905C181.48 41.5829 204.29 106.14 180.782 144.653L65.1041 144.653C63.8735 142.202 62.7863 139.64 61.8545 136.976C48.0151 97.4071 -3.20995 93.689 6.89011 44.5994Z",
    fill: "#F1F1F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 372"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22",
    opacity: 0.5,
    x: 0.955078,
    y: 46.9609,
    width: 70.7988,
    height: 25.4876,
    rx: 12.7438,
    fill: "#A2A2A8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23",
    x: 11.2568,
    y: 57.8906,
    width: 50.1956,
    height: 3.63672,
    rx: 1.81836,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 373"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22_2",
    opacity: 0.5,
    x: 81.7539,
    y: 46.9609,
    width: 43.5839,
    height: 25.4876,
    rx: 12.7438,
    fill: "#A2A2A8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23_2",
    x: 88.0957,
    y: 57.8906,
    width: 30.9005,
    height: 3.63672,
    rx: 1.81836,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 375"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22_3",
    opacity: 0.5,
    x: 0.955078,
    y: 82.4531,
    width: 43.5839,
    height: 25.4876,
    rx: 12.7438,
    fill: "#A2A2A8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23_3",
    x: 7.29688,
    y: 93.375,
    width: 30.9005,
    height: 3.63672,
    rx: 1.81836,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 374"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22_4",
    opacity: 0.5,
    x: 135.338,
    y: 46.9609,
    width: 59.7072,
    height: 25.4876,
    rx: 12.7438,
    fill: "#A2A2A8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23_4",
    x: 144.025,
    y: 57.8906,
    width: 42.3317,
    height: 3.63672,
    rx: 1.81836,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 376"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22_5",
    opacity: 0.5,
    x: 54.5391,
    y: 82.4531,
    width: 59.7072,
    height: 25.4876,
    rx: 12.7438,
    fill: "#A2A2A8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23_5",
    x: 63.2266,
    y: 93.375,
    width: 42.3317,
    height: 3.63672,
    rx: 1.81836,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 378"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M147.138 97.5748L162.383 112.688L157.862 114.542C157.344 114.753 157.097 115.35 157.312 115.867L160.017 122.337L155.696 124.114L152.979 117.621C152.764 117.099 152.157 116.856 151.64 117.079L147.138 119.036L147.138 97.5748ZM146.106 94.133C145.556 94.1452 145.115 94.5949 145.115 95.1441V120.576C145.111 121.304 145.859 121.799 146.529 121.509L151.504 119.344L154.214 125.818C154.429 126.332 155.015 126.574 155.533 126.368L161.735 123.822C162.252 123.607 162.5 123.013 162.285 122.495L159.571 116.023L164.562 113.979C165.232 113.704 165.407 112.836 164.889 112.326L146.839 94.4282C146.644 94.2362 146.381 94.1284 146.106 94.133Z",
    fill: "#A2A2A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M156.444 90.4797C156.289 90.4919 156.133 90.5386 155.998 90.6197L152.994 92.336C152.497 92.6068 152.317 93.2362 152.601 93.7296C152.883 94.2244 153.512 94.3874 153.999 94.0929L157.002 92.375C157.958 91.8541 157.528 90.4002 156.444 90.4797Z",
    fill: "#A2A2A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M140.709 99.4875C140.55 99.4998 140.399 99.5464 140.263 99.6275L137.259 101.344C136.761 101.615 136.582 102.244 136.865 102.737C137.143 103.232 137.776 103.395 138.263 103.101L141.266 101.383C142.223 100.861 141.793 99.408 140.709 99.4875Z",
    fill: "#A2A2A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M141.673 86.5396C140.903 86.5717 140.449 87.4161 140.848 88.0762L142.576 91.053C142.86 91.5349 143.477 91.6986 143.959 91.4194C144.445 91.1356 144.609 90.5191 144.329 90.0327L142.592 87.0566C142.409 86.7262 142.055 86.5274 141.673 86.5396Z",
    fill: "#A2A2A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M149.895 85.4545C149.453 85.4752 149.075 85.7811 148.963 86.2072L148.066 89.5419C147.903 90.088 148.222 90.6617 148.772 90.8085C149.321 90.9561 149.886 90.6219 150.017 90.0681L150.918 86.7418C151.107 86.0756 150.588 85.4186 149.895 85.4545Z",
    fill: "#A2A2A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M136.646 93.0787C135.471 93.1139 135.291 94.7874 136.431 95.0704L139.772 95.9584C140.322 96.1336 140.909 95.8108 141.056 95.254C141.208 94.6964 140.857 94.1258 140.291 94.0027L136.945 93.1193C136.844 93.0894 136.746 93.0749 136.646 93.0787Z",
    fill: "#A2A2A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecordRound);
export default __webpack_public_path__ + "static/media/no-record-round.d479db40897742b21e7c0028fef4c9d9.svg";
export { ForwardRef as ReactComponent };